import { useEffect, useState } from 'react';

// DEPENDENCIES
import isString from 'lodash/isString';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints';

// GLOBAL FUNCTIONS
import { apiFetch, makePath } from 'functions';

const useGetDealerSettings = (showLoading = true) => {
  const [settings, setSettings] = useState({});

  useEffect(() => {
    let isMounted = true;
    
    apiFetch({
      endpoint: makePath(ENDPOINTS.admin.dealerSettings),
      loadingMessage: showLoading && 'Loading Dealer Settings',
      errorMessage: 'Unable to load Dealer Settings.',
      onSuccess: data => {
        const result = data?.results || {};

        // Ensure homenet_setting_new only contains items that match make_ids
        const homeNetSettingNew = result.homenet_setting_new || [];
        const { make_ids } = result;
        let filteredByMakes = {
          ...result,
          homenet_setting_new: homeNetSettingNew.filter(h => {
            return make_ids && isString(make_ids) && make_ids.split(',').includes(String(h.makeid))
          })
        };

        if (isMounted) setSettings(filteredByMakes)
      }
    });

    return () => { isMounted = false };
  }, [showLoading]);

  return settings;
};

export default useGetDealerSettings;
